export default __webpack_public_path__ + "static/SRF 1025 - Fiche de spécifications et données techniques-a27deda7f9e7e43d73afbf21589fe990.pdf";